import type { GameMeta } from '@gmp/game-sdk';

export const rottenReviewsMeta = {
  id: 'rotten-reviews',
  name: 'Rotten Reviews',
  tagline: 'Run a ridiculous business. Survive the one-star reviews. Answer every single one.',
  description:
    'Each round one player owns a bizarre business: a haunted laundromat, an underwater hair salon. Everyone else posts an unreasonable one-star review from a secret prompt card. The owner answers each featured review: apologize, deny, bribe, explain or counterattack, with a reply line if they dare. Everyone else predicts how the owner will respond, then votes for the funniest review-and-reply pair. Play over a coffee break or over a week.',
  minPlayers: 3,
  maxPlayers: 12,
  estimatedMinutes: [15, 35],
  usesMedia: false,
  modes: [{ id: 'storefront', name: 'Storefront', description: 'Everyone owns a business once by default; the host can cap the rounds.' }],
  theme: { primary: '#ffb627', secondary: '#e2483d', background: '#1b1420', ink: '#fff6e6' },
  readiness: 'beta',
  genre: 'Customer-service comedy and social prediction',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [30, 90],
    match: { quick: '15–35 min', daily: '4–12 days' },
    difficulty: 'easy',
    tags: ['funny', 'writing', 'prediction'],
  },
  instructions: [
    { icon: 'Store', title: 'Open for business', body: 'Each round one player owns a bizarre business. Ownership rotates so everyone runs a shop.' },
    { icon: 'Star', title: 'Leave one star', body: 'Everyone else gets a secret prompt card ("blame them for the weather") and writes an unreasonable one-star review. Reviews stay anonymous until the reveal.' },
    { icon: 'MessageCircle', title: 'Respond or predict', body: 'The owner answers each featured review: apologize (safe), deny, explain, bribe (costs a coin) or counterattack (big, but it backfires if most people saw it coming). Everyone else predicts each response.' },
    { icon: 'Trophy', title: 'Vote and reveal', body: 'Vote for the funniest review-and-reply pair (never your own). Funny reviews, good predictions and a healthy star rating all score. Steps move on when everyone is in or the time runs out.' },
  ],
} satisfies GameMeta;
